import api from './apiService';

/**
 * Lista todas as notificações não lidas do usuário
 * @returns json
 */
export const getNotificationsNotRead = async () => {
    try {
        const response = await api.get('/notifications');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}


export const updateReadNotification = async (uuidNotification) =>{
    try {
        const response = await api.get(`/notifications/${uuidNotification}/read`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

